import React from 'react'
import {useTranslation} from 'react-i18next'

export default function TableHead() {
  const {t} = useTranslation()

  const headTable = [
    {
      name: t('srNo'),
      class: 'min-w-80px',
    },
    {
      name: t('category'),
      class: 'min-w-100px',
    },
    // {
    //   name: t('appearHome'),
    //   class: 'min-w-200px',
    // },
    {
      name: t('status'),
      class: 'min-w-200px',
    },

    {
      name: t('actions'),
      class: 'min-w-120px',
    },
  ]

  return (
    <thead>
      <tr className='fw-bold text-muted'>
        {headTable.map((e, i) => (
          <th
            style={{
              textAlign: i === 0 ? 'start' : 'start',
              width: i === headTable.length - 1 || i === 0 ? '110px' : 'auto',
            }}
            key={i}
            className={e.class}
          >
            {e.name}
          </th>
        ))}
      </tr>
    </thead>
  )
}
